import { render, staticRenderFns } from "./ShouldIBuy.vue?vue&type=template&id=248b07d4&scoped=true&"
import script from "./ShouldIBuy.vue?vue&type=script&lang=js&"
export * from "./ShouldIBuy.vue?vue&type=script&lang=js&"
import style0 from "./ShouldIBuy.vue?vue&type=style&index=0&id=248b07d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248b07d4",
  null
  
)

export default component.exports